
import section1 from './section/section1';

promokit.page({
    game: 'bns',

    cnb: true,

    footer: {
        fixed: true,
        theme: 'white' //'black', 'white'
    },

    headerButton: {
        el: '.header-button',
        cookie: {
            type: 'year',
            key: 'INDEX_WEB_VISIT_201113_update',
            value: false
        },
        update:true,
        home: true,
        sns: true,
        theme: 'white'
    },
    components: [
        section1,
    ],
});


promokit.preload({
    complete: () => {
        section1.enterStart();
    }
});

var video2 = promokit.youtube({
    el: '#player-1',
    youtubeid: 'Nasj3dWAWy0',
    poster: 'https://img.youtube.com/vi/Nasj3dWAWy0/mqdefault.jpg',
    preload: true,
    controls: true,
    youtubeLink:true
});


var layer1 = promokit.layer({
    el: '#layer-1',
    buttons: '.btn-line',
});

var layer2 = promokit.layer({
    el: '#layer-2',
    buttons: '.btn-detail5',
});

var layer3 = promokit.layer({
    el: '#layer-3',
    buttons: '.btn-video',
    render: true,
    autoplayVideo: video2
});

// 이미지 뷰어
let urlPath = promokit.store('staticPath');

var viewer1 = promokit.viewer({
    images: [
        {
            src: `${urlPath}/promo/bns/history/2020/201113_update/img/item/item1.png`,
            title: '독천'
        },
        {
            src: `${urlPath}/promo/bns/history/2020/201113_update/img/item/item2.png`,
            title: '독천'
        },
    ],
    buttons: '.btn-detail1'
});

var viewer2 = promokit.viewer({
    images: [
        {
            src: `${urlPath}/promo/bns/history/2020/201113_update/img/item/item3.png`,
            title: '흑월마녀'
        },
        {
            src: `${urlPath}/promo/bns/history/2020/201113_update/img/item/item4.png`,
            title: '흑월마녀'
        }
    ],
    buttons: '.btn-detail3'
});

$(document).on('click', '.btn-detail2', function(e) {
    viewer1.open(1);
});
$(document).on('click', '.btn-detail4', function(e) {
    viewer2.open(1);
});

//---------------------------
$(document).on('click', '.btn-bingo', function(e) {
    e.preventDefault();
    location.href = 'https://bns.plaync.com/events/2020/201111_festival/bingo';
    /*promokit.message({
        type: 'alert',
        message: '11월 18일에 확인하실 수 있습니다.'
    });*/
});
$(document).on('click', '.btn-update', function(e) {
    e.preventDefault();
    location.href = 'https://bns.plaync.com/board/update/view?articleId=46219651';
    /*promokit.message({
        type: 'alert',
        message: '11월 18일에 확인하실 수 있습니다.'
    });*/
});



// WEBPACK FOOTER //
// ./src/js/index.js